export default {
    en: {
        title: 'Contact us',
        subtitle: 'Need help? Get in touch with us for any questions or support regarding your career opportunities.'
    },
    no: {
        title: 'Kontakt oss',
        subtitle: 'Trenger du hjelp? Ta kontakt med oss hvis du har spørsmål eller trenger støtte angående dine karrieremuligheter.'
    },
    sv: {
        title: 'Kontakt oss',
        subtitle: 'Behöver du hjälp? Kontakta oss om du har frågor eller behöver stöd angående dina karriärmöjligheter.'
    }
} as const;
